import React, { useState } from "react";

function PackageConfirmationTravellerSection({ booking }) {
  const [expandedIndex, setExpandedIndex] = useState(null);

  if (!booking) return null;

  const travellers = booking?.reservationDetails || [];

  return (
    <div className="w-full flex flex-col gap-3">
      <span className="text-base font-bold lg:text-xl">Travellers</span>

      {/* Booking Summary */}
      <div className="border border-gray-300 rounded-md bg-gray-50 p-4 flex flex-wrap gap-4 text-sm">
        <div>
          <span className="text-gray-500">Schedule</span>
          <div className="font-medium">{booking.selectedSchedule}</div>
        </div>

        <div>
          <span className="text-gray-500">Payment</span>
          <div className="font-medium">{booking.paymentTime}</div>
        </div>

        <div>
          <span className="text-gray-500">Expiry</span>
          <div className="font-medium">
            {new Date(booking.expiryDate).toLocaleString()}
          </div>
        </div>

        <div>
          <span className="text-gray-500">Contact</span>
          <div className="font-medium">{booking.contactEmail}</div>
        </div>
        <div>
          <span className="text-gray-500">Phone</span>
          <div className="font-medium">{booking.contactPhoneNumber}</div>
        </div>
      </div>

      {/* Travellers */}
      {travellers.map((traveller, index) => {
        if (!traveller) return null;

        const expanded = expandedIndex === index;
        const fullName = `${traveller.firstName} ${traveller.lastName}`;

        return (
          <div
            key={index}
            className="w-full rounded-md flex flex-col border border-gray-300 bg-white"
          >
            <div className="w-full px-4 py-2 flex items-center gap-3 border-b border-gray-300">
              <div className="w-6 h-6 text-white bg-primary1 font-bold text-sm rounded-md flex items-center justify-center">
                {index + 1}
              </div>

              <span className="font-bold text-primary1 text-sm lg:text-base">
                {fullName}
              </span>

              <div className="flex flex-1" />

              <button
                className="text-sm gap-1 items-center flex"
                onClick={() => setExpandedIndex(expanded ? null : index)}
              >
                <span className="text-primary1">
                  {expanded ? "Hide details" : "See details"}
                </span>

                <img
                  src="/iconChevronUp.svg"
                  alt=""
                  className={`w-4 transition-all ${
                    expanded ? "" : "rotate-180"
                  }`}
                />
              </button>
            </div>

            {expanded && (
              <div className="flex flex-wrap gap-3 py-3 px-4 bg-gray-50">
                <div className="flex flex-col w-[31%]">
                  <span className="text-gray-500 text-xs">Full Name</span>
                  <span className="text-sm">{fullName}</span>
                </div>
                <div className="flex flex-col w-[31%]">
                  <span className="text-gray-500 text-xs">Gender</span>
                  <span className="text-sm">{traveller.gender}</span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default PackageConfirmationTravellerSection;
